import { useEffect } from 'react';

import { setIsCardOpen, useSelectIsCardOpen } from 'Deer/slice/DeerCollapsibleCard.slice';
import { useDispatch } from 'react-redux';
import { getValueFromUserPreference } from 'utils/helpers/collapsibleCardsUtils';

type UseLocalStorageStateProps = {
  localStorageKey: string;
  card: string;
  section: 'myData' | 'myDirectTeam' | 'mySkipTeam' | 'myCompany';
};

const useLocalStorageCards = ({ localStorageKey, card, section }: UseLocalStorageStateProps) => {
  const isCardOpen = useSelectIsCardOpen(section, card);
  const dispatch = useDispatch();

  useEffect(() => {
    const cardStateFromLocalStorage = getValueFromUserPreference(localStorageKey);

    dispatch(
      setIsCardOpen({
        card,
        section,
        isCardOpen: cardStateFromLocalStorage,
        localStorageKey,
      })
    );
  }, [dispatch, localStorageKey, card, section]);

  return isCardOpen;
};

export default useLocalStorageCards;
